import SectorCard from "./SectorCard";

const SectorsSection = ({ sectors, currentLang, onSectorClick }) => {
  const sectorImages = [
    "/assets/images/investSectors/1.webp",
    "/assets/images/investSectors/2.webp",
    "/assets/images/investSectors/2.webp",
    "/assets/images/investSectors/4.webp",
    "/assets/images/investSectors/5.webp",
  ];

  if (!sectors.length) return null;

  return (
    <div className="mb-16">
      <div className="text-center mb-12">
        <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
          {currentLang === "ar" ? "القطاعات الاستثمارية المتاحة" :
           currentLang === "fr" ? "Secteurs d'Investissement Disponibles" : "Available Investment Sectors"}
        </h2>
        <p className="text-xl text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
          {currentLang === "ar" ? "اختر القطاع الذي يناسب خبرتك واستثمارك" :
           currentLang === "fr" ? "Choisissez le secteur qui correspond à votre expertise et investissement" :
           "Choose the sector that matches your expertise and investment"}
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {sectors.map((sector, idx) => (
          <SectorCard
            key={sector.id || idx}
            sector={sector}
            image={sectorImages[idx % sectorImages.length]}
            currentLang={currentLang}
            onClick={() => onSectorClick(sector)}
          />
        ))}
      </div>
    </div>
  );
};

export default SectorsSection;